const env = 'dev'
// const env = 'prd'

export const ROLES_PERFILES = env === 'dev' ? {
  PROFILES: {
    ADMCODE: 1220070,
    STORE_MANAGERCODE: 1220071
  }
} : {
  PROFILES: {
    ADMCODE: 10,
    STORE_MANAGERCODE: 1220071
  }
}
